import { connect } from "react-redux";

import PatientDetails from "../Component";

const mapStateToProps = () => ({
  item: null,
});

export default connect(mapStateToProps)(PatientDetails);
